<template>
  <v-app-bar
    v-scroll="onScroll"
    app
    elevate-on-scroll
    :color="!isScrolling ? 'transparent' : 'grey lighten-3'"
  >
    <v-img class="shrink" src="/static/qk-logo.png" />
    <v-spacer />
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-btn to="/" class="text-capitalize subtitle-1 mx-1" text> Home </v-btn>

      <v-btn @click="gotoEmpirica" class="text-capitalize subtitle-1 mx-1" color="red" text>
        Empirica
      </v-btn>

      <v-btn to="/notify" class="text-capitalize subtitle-1 mx-1" text>
        Notify
      </v-btn>

      <v-btn to="/profile" class="text-capitalize subtitle-1 mx-1" text>
        Profile
      </v-btn>

      <v-btn v-if="isAdmin" to="/users" class="text-capitalize subtitle-1 mx-1" text>
        Users
      </v-btn>

      <v-btn to="/changepassword" class="text-capitalize subtitle-1 mx-1" text>
        Change password
      </v-btn>
      <v-btn class="text-capitalize subtitle-1 mx-1" text @click="onSignOut"
        >Log Out</v-btn
      >
    </template>
    <v-menu v-else>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-card color="primary" dark>
        <v-list color="transparent">
          <v-list-item v-for="(item, i) in items" :key="i" :to="item.to">
            <v-list-item-title v-text="item.text" />
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
// Utilities
import { mapMutations } from "vuex";
import { Auth } from "aws-amplify";
import FullPageLayoutUnauth from "@/layouts/FullPageLayoutUnauth";

export default {
  data: () => ({
    isScrolling: false,
    items: [
      {
        to: "/",
        text: "Home",
      },
      {
        to: "/emperica",
        text: "Emperica",
      },
      {
        to: "/notify",
        text: "Notify",
      },
      {
        to: "/profile",
        text: "Profile",
      },
      {
        to: "/users",
        text: "Users",
      },
      {
        to: "/changepassword",
        text: "Change password",
      },
    ],
    isAdmin: false,
  }),

  async created() {
    const role = await this.isAdminRole;
    this.isAdmin = role ? true : false;
    // if (!this.isAdmin) {
    //   this.items.splice(3, 1); // Remove Users button
    // }
  },

  methods: {
    ...mapMutations(["toggleDrawer"]),
    onScroll() {
      this.isScrolling =
        (window.pageYOffset || document.documentElement.scrollTop || 0) > 20;
    },
    onSignOut() {
      Auth.signOut()
        .then((data) => {
          this.$store.commit("updateAuthState", false);
          this.$store.state.user = null;
          this.$store.state.signedIn = !!data;
          this.$cookie.delete("AWSTOKEN");
          this.$router.push({ path: "login" });
          location.reload();
        })
        .catch((err) => console.log(err));
    },
    gotoEmpirica() {
      window.open(
        process.env.VUE_APP_AWS_EMPIRICA,
        "_blank"
      );
    },
  },
  computed: {
    async isAdminRole() {
      const user = await Auth.currentAuthenticatedUser();
      const awsGroups =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      if (awsGroups) {
        const roles =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        return roles.includes("ADMIN");
      }
    },
  },
};
</script>
